import {
    bet,
    madnes_get_json
} from "../framework/src/engine/madnes/madnes";

import {
    he,
    picture_convert,
    server_config, states, systemConfig,
    wi
} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_add_group,
    madnes_add_img,
    madnes_add_to_group,
    madnes_get_dimension_wi,
    madnes_set_img_center,
    madnes_set_pos, madnes_set_pos_x,
    madnes_set_pos_y,
    madnes_set_scale,
    madnes_set_visible, madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_add_bitmap_text,
    madnes_add_text, madnes_format_text,
    madnes_set_font_size,
    madnes_set_text
} from "../framework/src/engine/madnes/madnes_text";
import {end_standing_symbols, start_standing_symbols} from "./ps_anims";
import {main_phaser, wintable_phaser} from "../framework/src/engine/madnes/MadnesApp";
import {madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {CONFIG_PARAMS} from "../framework/src/system/SystemConfig";
import {STATES} from "../framework/src/states/states";

export let openinfo = false;

var info_pos = 0;
var infotable_count = 4;

var slideCallbackOnce = null;

let phaser = main_phaser;

export let origFontSize = 80;

var wintable2_offset = 0;

var slides = {
    1: {
        'symbol_Mystery': {
            5: { 'name': '5x_symbol_Mystery', 'textx': 990, 'texty': 218 },
            4: { 'name': '4x_symbol_Mystery', 'textx': 990, 'texty': 260 },
            3: { 'name': '3x_symbol_Mystery', 'textx': 990, 'texty': 300 }
        },

        'symbol_Wild': {
            5: { 'name': '5x_symbol_Wild', 'textx': 600, 'texty': 478 },
            4: { 'name': '4x_symbol_Wild', 'textx': 600, 'texty': 520 },
            3: { 'name': '3x_symbol_Wild', 'textx': 600, 'texty': 562 }
        },
        'symbol_King': {
            5: { 'name': '5x_symbol_King', 'textx': 990, 'texty': 476 },
            4: { 'name': '4x_symbol_King', 'textx': 990, 'texty': 520 },
            3: { 'name': '3x_symbol_King', 'textx': 990, 'texty': 561 }
        }
    },
    2: {
        'symbol_Queen': {
            5: { 'name': '5x_symbol_Queen', 'textx': 595 + (wintable2_offset * 1), 'texty': 218 },
            4: { 'name': '4x_symbol_Queen', 'textx': 595 + wintable2_offset * 1, 'texty': 260 },
            3: { 'name': '3x_symbol_Queen', 'textx': 595 + wintable2_offset * 1, 'texty': 302 }
        },
        'symbol_Princess': {
            5: { 'name': '5x_symbol_Princess', 'textx': 980 + wintable2_offset * 1, 'texty': 218 },
            4: { 'name': '4x_symbol_Princess', 'textx': 980 + wintable2_offset * 1, 'texty': 260 },
            3: { 'name': '3x_symbol_Princess', 'textx': 980 + wintable2_offset * 1, 'texty': 302 }
        },
        'symbol_Nix': {
            5: { 'name': '5x_symbol_Nix', 'textx': 780 + wintable2_offset * 1, 'texty': 478 },
            4: { 'name': '4x_symbol_Nix', 'textx': 780 + wintable2_offset * 1, 'texty': 520 },
            3: { 'name': '3x_symbol_Nix', 'textx': 780 + wintable2_offset * 1, 'texty': 562 }
        }
    }
};

export function ps_infomenu_init()
{
    phaser = wintable_phaser || main_phaser;

    // settings_background_pos = 1;

    madnes_add_group("settings_group_0", phaser);
    madnes_set_pos("settings_group_0", -9999, -9999);
    madnes_add_img("wintable_bg_1", "wintable_bg", 0, 0);
    if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
        madnes_add_img("wintable_1", "wintable_1_es", wintable2_offset, 0);
    } else {
        madnes_add_img("wintable_1", "wintable_1", 0, 0);
    }
    madnes_add_to_group("settings_group_0", "wintable_bg_1");
    madnes_add_to_group("settings_group_0", "wintable_1");
    madnes_set_visible("settings_group_0", false);

    madnes_add_group("settings_group_1", phaser);
    madnes_set_pos("settings_group_1", -9999, -9999);
    madnes_add_img("wintable_bg_2", "wintable_bg", 0, 0);
    madnes_add_to_group("settings_group_1", "wintable_bg_2");
    madnes_add_img("wintable_2", "wintable_2", wintable2_offset, 0);
    madnes_add_to_group("settings_group_1", "wintable_2");
    madnes_set_visible("settings_group_1", false);

    madnes_add_group("settings_group_2", phaser);
    madnes_set_pos("settings_group_2", -9999, -9999);
    madnes_add_img("infotable_3", "wintable_bg", 0, 0);
    madnes_add_to_group("settings_group_2", "infotable_3");
    madnes_set_visible("settings_group_2", false);

    madnes_add_group("settings_group_3", phaser);
    madnes_set_pos("settings_group_3", -9999, -9999);
    madnes_add_img("infotable_4", "wintable_bg", 0, 0);
    madnes_add_to_group("settings_group_3", "infotable_4");
    madnes_set_visible("settings_group_3", false);

    madnes_add_img("settings_mystery", "symbols_atlas", 100, 45, 1, 0, 0, "symbol_Mystery");
    madnes_set_scale("settings_mystery", 0.7, 0.7);
    madnes_add_to_group("settings_group_3", "settings_mystery");

    madnes_add_img("settings_wild", "symbols_atlas", 100, 230, 1, 0, 0, "symbol_Wild");
    madnes_set_scale("settings_wild", 0.7, 0.7);
    madnes_add_to_group("settings_group_3", "settings_wild");

    madnes_add_img("settings_bonus", "symbols_atlas", 100, 430, 1, 0, 0, "symbol_Scatter");
    madnes_set_scale("settings_bonus", 0.7, 0.7);
    madnes_add_to_group("settings_group_3", "settings_bonus");

    /*if(madnes_get_language() != "sk")
    {
        madnes_add_group("settings_group_5");
        madnes_set_pos("settings_group_5", -9999, -9999);
        madnes_add_img("infotable_5", "infotable_5", 0, 0);
        madnes_add_to_group("settings_group_5", "infotable_5");
        madnes_set_visible("settings_group_5", false);

        infotable_count = 5;
    }*/

    madnes_add_group("curtain", phaser);

    madnes_add_img("reel_left_wt", "reels_atlas", 0, 0);
    madnes_sprite_set_frame_name("reel_left_wt", "reel_cover_left");
    madnes_add_to_group("curtain", "reel_left_wt");

    madnes_add_img("reel_right_wt", "reels_atlas", wi, 0);
    madnes_set_img_center("reel_right_wt", 1, 0);
    madnes_sprite_set_frame_name("reel_right_wt", "reel_cover_right");
    madnes_add_to_group("curtain", "reel_right_wt");

    madnes_add_img("reel_top_wt", "reels_atlas", 102, 0);
    madnes_sprite_set_frame_name("reel_top_wt", "reel_cover_top");
    madnes_add_to_group("curtain", "reel_top_wt");

    madnes_add_img("reel_bottom_wt", "reels_atlas", 102, he);
    madnes_set_img_center("reel_bottom_wt", 0, 1);
    madnes_sprite_set_frame_name("reel_bottom_wt", "reel_cover_bottom");
    madnes_add_to_group("curtain", "reel_bottom_wt");

//
//	madnes_add_img("curtain_left", "settings_curation", -9999, -9999);
//	madnes_set_visible("curtain", false);


    for(var slideIndex in slides) {
        var slide = slides[slideIndex];
        for(var sym in slide) {
            for(var i in slide[sym]) {
                var symbTextName = slide[sym][i]['name'];
                var textx = slide[sym][i]['textx'];
                var texty = slide[sym][i]['texty'];

                //var bgx = slide[sym][i].bgx;
                //var bgy = slide[sym][i].bgy;

                madnes_add_bitmap_text(symbTextName, 'font_winplane', textx, texty, "", origFontSize);
                madnes_set_img_center(symbTextName, 1, 1);

                madnes_add_to_group("settings_group_" + (slideIndex - 1), symbTextName);
            }
        }
    }

    ps_infomenu_update();

    var infotext = madnes_get_json("infotext")["infomenuPages"];

    for(var i in infotext)
    {
        var x = infotext[i]["position"][0];
        var y = infotext[i]["position"][1];

        var page = infotext[i]["page"];
        var lineHeight0 = infotext[i]["title"]["lineHeight"];
        var lineHeight1 = infotext[i]["lineHeight"];

        var style0 = {
            "font": "32px Arial",
            "fill": "#faba41",
            "fontWeight": "",
        };
        var style1 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };

        if(infotext[i]["fontSize"] && infotext[i]["font"])
        {
            style0["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
            style1["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
        }

        if(infotext[i]["color"])
        {
            style0["fill"] = infotext[i]["color"];
            style1["fill"] = infotext[i]["color"];
        }
        if(infotext[i]["bold"])
        {
            if(infotext[i]["bold"] == 1)
            {
                style0["fontWeight"] = "bold";
                style1["fontWeight"] = "bold";
            }
            else if(infotext[i]["bold"] == 0)
            {
                style0["fontWeight"] = "";
                style1["fontWeight"] = "";
            }
        }

        var line0 = 0;
        var line1 = 0;

        for(var j in infotext[i]["title"]["content"])
        {
            var text = infotext[i]["title"]["content"][j];
            var textName = "info_header_" + i + "_"  + j + "_" + line0;
            var groupName = "settings_group_" + ( page * 1 + 1 );

            madnes_add_text(textName, x, y + line0 * lineHeight0, text, style0);
            madnes_add_to_group(groupName, textName);
            line0++;
        }

        for(var j in infotext[i]["body"]["content"])
        {
            var text = infotext[i]["body"]["content"][j];
            madnes_add_text("info_body_" + i + "_"  + j + "_" + line1, x, y + line0 * lineHeight0 + line1 * lineHeight1, text, style1);
            madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_body_" + i + "_"  + j + "_" + line1);
            line1++;
        }
    }
}


function set_info_sums()
{
    for(var sIndex in slides) {
        var slide = slides[sIndex];

        for(var sym in slide) {

            if(sym == 'symbol_Mystery') {
                continue;
            }

            var symIndex = picture_convert.indexOf(sym);
            var factors = server_config.logic.symbols[symIndex]['factors'];

            for(var fIdx in factors) {

                var textIndex = fIdx * 1 + 1;

                if(typeof slide[sym][textIndex] == 'undefined') {
                    continue;
                }

                var symbTextName = slide[sym][textIndex]['name'];
                var factor = factors[fIdx];

                if(factor <= 0) {
                    factor = 1;
                }

                madnes_set_text(symbTextName, bet * factor);
            }
        }
    }

    var factRanges = server_config['logic']['specifics']['mysteryFactorRanges'];

    madnes_set_text("5x_symbol_Mystery", madnes_format_text(factRanges[2]['min'] * 1 * bet) + "-" + madnes_format_text(factRanges[2]['max'] * 1 * bet));
    madnes_set_font_size("5x_symbol_Mystery", origFontSize);
    madnes_set_text("4x_symbol_Mystery", madnes_format_text(factRanges[1]['min'] * 1 * bet) + "-" + madnes_format_text(factRanges[1]['max'] * 1 * bet));
    madnes_set_font_size("4x_symbol_Mystery", origFontSize);
    madnes_set_text("3x_symbol_Mystery", madnes_format_text(factRanges[0]['min'] * 1 * bet) + "-" + madnes_format_text(factRanges[0]['max'] * 1 * bet));
    madnes_set_font_size("3x_symbol_Mystery", origFontSize);

    var fSize = calcFontSize(origFontSize, 235, madnes_get_dimension_wi("5x_symbol_Mystery"));

    madnes_set_font_size("5x_symbol_Mystery", fSize);
    madnes_set_font_size("4x_symbol_Mystery", fSize);
    madnes_set_font_size("3x_symbol_Mystery", fSize);

    var textShift = get_text_shift(origFontSize, fSize);

    madnes_set_pos_y("5x_symbol_Mystery", slides[1]['symbol_Mystery'][5]['texty'] - textShift);
    madnes_set_pos_y("4x_symbol_Mystery", slides[1]['symbol_Mystery'][4]['texty'] - textShift);
    madnes_set_pos_y("3x_symbol_Mystery", slides[1]['symbol_Mystery'][3]['texty'] - textShift);
}

export function get_text_shift(origFontSize, fSize)
{
    return Math.round((origFontSize - fSize) / 8);
}

export function calcFontSize(origFontSize, origWidth, newWidth)
{
    if(origWidth > newWidth) {
        return origFontSize;
    }

    return Math.round((origWidth / newWidth) * origFontSize * 100) / 100;
}

export function ps_infomenu_open()
{
//	madnes_set_pos("curtain", 0, 0);
//	madnes_set_visible("curtain", true);

    //madnes_set_visible("logo_reels", false);

    end_standing_symbols();

    madnes_set_visible("settings_group_" + info_pos, true);
    madnes_set_pos("settings_group_" + info_pos, 0, 0);

    // settings_background_pos = 1;

    // for(var i = 0; i < infotable_count; i++)
    // {
    // 	madnes_set_pos("settings_group_" + i, 2500, 0);
    // 	madnes_set_visible("settings_group_" + i, true);
    // }

    // madnes_set_pos("settings_group_0", 0, 0);

    openinfo = true;
}

export function ps_infomenu_close()
{
//	madnes_set_pos("curtain", -9999, -9999);
//	madnes_set_visible("curtain", false);

    madnes_set_visible("logo_reels", true);

    if (states.getState() === STATES.IDLE) {
        start_standing_symbols();
    }

    for(var i = 0; i < infotable_count; i++)
    {
        madnes_set_pos("settings_group_" + i, -9999, -9999);
        madnes_set_visible("settings_group_" + i, false);
    }

    openinfo = false;
}

// function infomenu_click()
// {
// 	madnes_audio_play("bet");
// 	infomenu_update();
// }

export function ps_infomenu_update()
{
    setTimeout(function() {
        set_info_sums();
    }, 100);

}

export function ps_infomenu_left()
{
    if(!openinfo) {
        return;
    }

    menu_swipe(-1, info_pos - 1);
}

export function ps_infomenu_right()
{
    if(!openinfo) {
        return;
    }

    menu_swipe(1, info_pos + 1);
}

export function ps_infomenu_home() {

    if(info_pos == 0) {
        return;
    }

    if(!wt_swipe_lock) {
        menu_swipe(-1, 0);
    } else {
        slideCallbackOnce = () => {
            menu_swipe(-1, 0);
        }
    }
}

var wt_swipe_lock = false;
function menu_swipe(dir, next)
{
    if(wt_swipe_lock) {
        return false;
    }

    var prev_pos = info_pos;
    var info_pos_new = next; //info_pos + dir;

    if(info_pos_new > infotable_count - 1) {
        info_pos_new = 0;
    }

    if(info_pos_new < 0) {
        info_pos_new = infotable_count - 1;
    }
    info_pos = info_pos_new;

    madnes_set_pos("settings_group_" + (info_pos_new), wi * dir, 0);

    let x = wi * dir;

    wt_swipe_lock = true;

    // madnes_move_to("settings_group_" + (info_pos), wi * dir * -1, null, 250);
    madnes_tween_to("settings_group_" + (prev_pos), {x: wi * dir * -1}, {
        'duration': 250,
        'update': function (tween, perc) {

            madnes_set_pos_x("settings_group_" + (prev_pos), x * -1 * perc);
            madnes_set_pos_x("settings_group_" + (info_pos_new), x - (x * perc));
            // console.log(x.x, y, z);
        },
        'callback': () => {
            madnes_set_pos_x("settings_group_" + (prev_pos), x * -1);
            madnes_set_pos_x("settings_group_" + (info_pos_new), 0);

            wt_swipe_lock = false;

            slideCallbackOnce && slideCallbackOnce();
            slideCallbackOnce = null;
        }
    }, phaser);

    madnes_set_visible("settings_group_" + (info_pos_new), true);
}

// function infomenu_move()
// {
// 	var difftime = madnes_get_currtime() - move_start;
// 	var end = 0;
// 	if(difftime > move_total)
// 	{
// 		difftime = move_total;
// 		end = 1;
// 	}
//
// 	settings_background_pos2 = settings_background_pos * 1 + ( infomenu_move_dir * -1 );
// 	if(settings_background_pos2 > infotable_count)
// 	{
// 		settings_background_pos2 = 1;
// 	}
// 	if(settings_background_pos2 < 1)
// 	{
// 		settings_background_pos2 = infotable_count;
// 	}
//
// 	var pos1 = wi * ( ( ( 100 / move_total ) * difftime ) / 100 ) * infomenu_move_dir;
// 	var pos2 = 0;
// 	if(infomenu_move_dir < 0)
// 	{
// 		pos2 = pos1 + wi;
// 	}
// 	else
// 	{
// 		pos2 = wi * -1 + pos1;
// 	}
//
// 	madnes_set_pos_x("settings_group_" + settings_background_pos, pos1);
// 	madnes_set_pos_x("settings_group_" + settings_background_pos2, pos2);
//
// 	if(end == 1)
// 	{
// 		madnes_rem_from_render(infomenu_move);
//
// 		madnes_set_pos_x("settings_group_" + settings_background_pos2, 0);
// 		madnes_set_pos_x("settings_group_" + settings_background_pos, 2500);
//
// 		settings_background_pos = settings_background_pos2;
// 		infomenu_move_in = 0;
// 		infomenu_move_dir = 0;
// 	}
// }